import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import { EditScheduleComponent } from './edit-schedual/edit-schedual.component';

import Swal from 'sweetalert2';
import * as Chart from 'chart.js';
import { SchedualDetailService } from './schedual-detail.service';
declare var $: any;


@Component({
  selector: "smart-schedual-detail",
  templateUrl: "./schedual-detail.component.html",
  styleUrls: [
    "./schedual-detail.component.css",
    "../platform-color/platform-color.css",
  ],
})
export class SchedualDetailComponent implements OnInit, OnDestroy {
  @ViewChild(EditScheduleComponent) editSchedule: EditScheduleComponent;

  userRole = sessionStorage.getItem("role");
  accountId: string;
  farmId: string;
  plotId: string;
  cropId: string;
  zoneId: string;
  sensorId: string;
  thingId: string;

  arrData: any = [];
  thingsByid: any;
  sensor: any;
  things: any;
  datenow: any;
  textControl: any;
  lineChart: any = []; //ประกาศตัวแปรเก็บค่า
  arrDataSensor: any = [];
  mode: any;
  textSetting: any;
  arrSetting: any;
  settingMode: any;
  arrdataDel: any;
  txtContiionOne: any;
  showEdit = false;
  plot: any;
  onlineConfigs = [];
  loadConfig: boolean = false;
  constructor(
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private farmService: FarmService,
    private cdRef: ChangeDetectorRef,
    private schedualDetailService: SchedualDetailService
  ) {}

  ngOnInit() {
    this.farmId = this.route.snapshot.queryParams["farmId"];
    this.plotId = this.route.snapshot.queryParams["plotId"];
    this.cropId = this.route.snapshot.queryParams["cropId"];
    this.zoneId = this.route.snapshot.queryParams["zoneId"];
    this.sensorId = this.route.snapshot.queryParams["sensorId"];
    this.thingId = this.route.snapshot.queryParams["thingId"];
    
    sessionStorage.setItem("farmId", this.farmId);

    this.spinner.show();
    this.getDatenow();
    this.getSchedualAndCondition();
    this.getPlot();
    this.getThingsById(this.thingId, this.sensorId);
  }

  ngOnDestroy() {
    $("#setSchedual").modal("hide");
    $("#setControllabel").modal("hide");
    $("#setActive").modal("hide");
    $("#DeleteSch").modal("hide");
    $("#editSchedual").modal("hide");
    this.cdRef.detectChanges();
  }

  openEditModal() {
    this.editSchedule.reload();
  }

  getOnlineConfig(){
    let filter = {
      thing_id: this.thingId
    }
    this.farmService.getThingMGL(filter).subscribe(res=>{
      if(res.code == 200){
        this.accountId = res.data.ThingInfo.AccountId;

        this.farmService.getOnlineConfig(
          {
            account_id: this.accountId
          }
        ).subscribe((res) => {
          this.spinner.show();
          if (res.code == 200) {
            this.onlineConfigs = res.data.OnlineConfigInfo;
    
            this.loadConfig = true;
            this.spinner.hide();
          }else{
            this.loadConfig = true;
            this.spinner.hide();
          }
        });
      }else{
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด ไม่พบข้อมูลอุปกรณ์",
          showConfirmButton: false,
          timer: 1500,
        }).then(res=>{
          this.loadConfig = true;
          this.spinner.hide();
        })
      }
    })
  }

  getPlot() {
    this.spinner.show();
    this.farmService
      .getPlotDetailByID(this.plotId)
      .subscribe(async (success) => {
        if (success.code == 200) {
          this.plot = success.data[0];
        }
        this.spinner.hide();
      });
  }

  getSchedule(data) {
    // this.arraySchedule
    let day = [];
    let time = [];
    let time1 = [];
    let dayENG = [];
    day[0] = "-";
    day[1] = "จ.";
    day[2] = "อ.";
    day[3] = "พ.";
    day[4] = "พฤ.";
    day[5] = "ศ.";
    day[6] = "ส.";
    day[7] = "อา.";

    dayENG[0] = "-";
    dayENG[1] = "MON";
    dayENG[2] = "TUE";
    dayENG[3] = "WED";
    dayENG[4] = "THU";
    dayENG[5] = "FRI";
    dayENG[6] = "SAT";
    dayENG[7] = "SUN";

    for (let index = 0; index < 24; index++) {
      const element = index;

      var foundThing = data.find(function (elementD) {
        return elementD.starttime == element;
      });

      time.push({
        id: element.toString(),
      });

      time1.push({
        id: element.toString(),
        value: 0,
        unit: "",
      });
    }

    // for (let index = 0; index < day.length; index++) {
    //   const element = day[index];

    //   if (element != null) {
    //     if (element == "-") {
    //       this.arraySchedule.push({
    //         day: element,
    //         dayEng: dayENG[index],
    //         time: time1
    //       })
    //     } else {
    //       this.arraySchedule.push({
    //         day: element,
    //         dayEng: dayENG[index],
    //         time: time
    //       })
    //     }
    //   }
    // }
  }

  getSchedualAndCondition() {
    this.spinner.show();
    setTimeout(async () => {
      this.farmService
        .getAllScheduleAndCodition(this.plotId, this.thingId, this.sensorId)
        .subscribe(async (success) => {
          let newArrDay = [];
          if (success.code == 200) {
            success.data.forEach(async (element) => {
              if (element.DateNumberArray.length > 0) {
                for (let index = 0; index < element.DateArray.length; index++) {
                  const elementDate = element.DateArray[index];
                  newArrDay.push({
                    day: elementDate,
                    dayNo: element.DateNumberArray[index],
                  });
                }
              }

              let groupNewArrDay = newArrDay.reduce((r, a) => {
                (r[a.day] = r[a.day] || []).push(a);
                return r;
              }, {});

              if (element.condition != null) {
                let parseArr = JSON.parse(element.condition);
                // let dtCon = await this.getSensorofCondition(element.condition)
                if (element.DateNumberArray.length > 0) {
                  this.arrData.push({
                    data: element,
                    condition: parseArr,
                    day: groupNewArrDay,
                  });
                } else {
                  this.arrData.push({
                    data: element,
                    condition: parseArr,
                    day: null,
                  });
                }
              } else {
                if (element.DateNumberArray.length > 0) {
                  this.arrData.push({
                    data: element,
                    condition: [],
                    day: groupNewArrDay,
                  });
                } else {
                  this.arrData.push({
                    data: element,
                    condition: [],
                    day: null,
                  });
                }
              }
            });
            if (this.arrData != "") {
              $("#schedual_auto").prop("disabled", false);
            }
            this.getSchedule(this.arrData);
            this.cdRef.detectChanges();
            this.spinner.hide();
          }
        });
    }, 100);
  }

  convertUnit(data) {
    let unit = [];

    unit["seconds"] = "วินาที";
    unit["minutes"] = "นาที";
    unit["hours"] = "ชั่วโมง";

    return unit[data];
  }

  convertDay(data) {
    let day = [];

    day["Daily"] = "รายวัน";
    day["Weekly"] = "รายสัปดาห์";
    day["Monthly"] = "รายเดือน";
    day["null"] = "เงื่อนไข";

    return day[data];
  }

  getThingsById(id, sensor) {
    this.spinner.show();
    setTimeout(async () => {
      this.farmService
        .getThingById(this.farmId, this.plotId)
        .subscribe(async (success) => {
          if (success.code == 200) {
            this.thingsByid = success.data;
            var foundThing = this.thingsByid.find(function (element) {
              return element.thing_id == id;
            });

            if (foundThing.control != undefined) {
              foundThing.control.forEach((element) => {
                if (element.sensor_id == sensor) {
                  this.sensor = element;
                }
              });
            }
            this.things = foundThing;

            if(this.sensor.auto_sync_flag){
              this.getOnlineConfig();
            }
            this.spinner.hide();
          }
        });
    }, 100);
  }

  selectDetailSchedule(id, day, data) {
    let arrText = [];
    let arrdayMrg = [];
    let arrUNdayMrg = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      if (element.dayMrg != null) {
        arrdayMrg.push(element);
      } else {
        arrUNdayMrg.push(element);
      }
    }

    for (let index = 0; index < arrdayMrg.length; index++) {
      const element = arrdayMrg[index];
      var text =
        "ประเภท : " +
        this.convertDay(element.data.sch_type) +
        "<br>" +
        "วันที่ " +
        element.dayMrg[day][index].dayNo +
        " " +
        this.datenow +
        "<br>" +
        "เริ่มเวลา " +
        element.data.sch_start_time +
        " น. เป็นเวลา " +
        element.data.sch_time +
        " " +
        this.convertUnit(element.data.sch_unit_time);
      arrText.push(text);
    }

    for (let index = 0; index < arrUNdayMrg.length; index++) {
      const element = arrUNdayMrg[index];
      var text =
        "ประเภท : " +
        this.convertDay(element.data.sch_type) +
        "<br>" +
        "เริ่มเวลา " +
        element.data.sch_start_time +
        " น. เป็นเวลา " +
        element.data.sch_time +
        " " +
        this.convertUnit(element.data.sch_unit_time);
      arrText.push(text);
    }

    $("#dtPOP" + id + day).popover({
      title: "<h2>รายละเอียด<h2><hr>",
      content: "<p>" + arrText.join("</p><p>") + "</p>",
      html: true,
      placement: "top",
    });

    $("#dtPOP" + id + day).popover("show");
  }

  getDatenow() {
    const eventNow = new Date();
    const optionsNow = { year: "numeric", month: "long" } as const;

    this.datenow = eventNow.toLocaleDateString("th-TH", optionsNow);
  }

  openControl(sensor, mode) {
    $("#setControllabel").modal("show");
    if (mode == 0) {
      this.textControl =
        "คุณต้องการเปลี่ยนการทำงาน " +
        sensor.sensor_name +
        " เป็น MANUAL ใช่หรือไม่";
    } else {
      this.textControl =
        "คุณต้องการเปลี่ยนการทำงาน " +
        sensor.sensor_name +
        " เป็น AUTO ใช่หรือไม่";
    }
    this.arrDataSensor = sensor;
    this.mode = mode;
  }

  async updateControl(sensor, mode) {
    let data = {
      sensor_type_status: mode,
      thing_id: sensor.thing_id,
      sensor_id: sensor.sensor_id,
    };

    this.farmService.getUpdateControlbyId(data).subscribe(async (success) => {
      $("#setControllabel").modal("hide");
      if (success.code == 200) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการเสร็จสิ้น",
          showConfirmButton: false,
          timer: 1000,
        }).then((res) => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          showConfirmButton: false,
          timer: 1000,
        }).then((res) => {
          window.location.reload();
        });
      }
    });
  }

  setActive(data) {
    $("#setActive").modal("show");

    if (data.data.sch_status == "ATV") {
      this.textSetting = "คุณต้องการเปลี่ยนแปลงเป็น Inactive ใช่หรือไม่";
      this.settingMode = "ITV";
    } else {
      this.textSetting = "คุณต้องการเปลี่ยนแปลงเป็น Active ใช่หรือไม่";
      this.settingMode = "ATV";
    }

    this.arrSetting = data;
  }
  Chart(data, dateValue) {
    $("#sensor_chart_report").replaceWith(
      $('<canvas id="sensor_chart_report" width=100 height=50></canvas>')
    );

    this.lineChart = new Chart("sensor_chart_report", {
      // สร้าง object และใช้ชื่อ id lineChart ในการอ้างอิงเพื่อนำมาเเสดงผล
      type: "line", // ใช้ชนิดแผนภูมิแบบเส้นสามารถเปลี่ยนชิดได้
      data: {
        // ข้อมูลภายในแผนภูมิแบบเส้น
        labels: dateValue, // ชื่อของข้อมูลในแนวแกน x
        datasets: data,
      },
      options: {
        title: {
          // ข้อความที่อยู่ด้านบนของแผนภูมิ
          // text: "Total members and Active members",
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        tooltips: {
          mode: "nearest",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
      },
    });
  }

  updateSetting(item, status) {
    let data = {
      thing_id: this.thingId,
      sensor_id: this.sensorId,
      sch_id: item.data.sch_id,
      sch_flag: status,
      sch_start_time: item.data.sch_start_time,
      id: item.data.id,
    };

    // let conditions = JSON.parse(item.data.condition);
    // if(this.sensor.auto_sync_flag && item.data.online_config_id && conditions.length == 1){
    //   this.farmService.getOnlineConfigById(item.data.online_config_id).subscribe(res=>{
    //     if(res.code == 200){
    //       let keyBasic = conditions[0].sensor_name;
    //       let thingName = conditions[0].thing_name;

    //       let config = res.data.OnlineConfigInfo;
    //       if(status =="ITV"){
    //         config.CustomDetails[keyBasic] = "0";
    //       }else{
    //         let filters = this.arrData.filter(arr=> item.condition.find(con=> con.sensor_name == keyBasic && con.thing_name == thingName) && item.data.id != arr.data.id && arr.data.sch_status =="ITV");
    //         if(filters.length ==0){
    //           config.CustomDetails[keyBasic] = "1";
    //         }
    //       }
    //       this.farmService.updateOnlineConfig(config, config.OnlineConfigId).subscribe(res=>{
    //         if(res.code == 200){
    //           this.farmService.getUpdateActiveSchedule(data).subscribe(async success => {
    //             $('#setActive').modal('hide');
    //             if (success.code == 200) {
    //               Swal.fire({
    //                 icon: 'success',
    //                 title: 'ดำเนินการเสร็จสิ้น',
    //                 showConfirmButton: false,
    //                 timer: 1000
    //               }).then(res=>{
    //                 window.location.reload();
    //               })
    //             } else {
    //               Swal.fire({
    //                 icon: 'error',
    //                 title: 'เกิดข้อผิดพลาด',
    //                 showConfirmButton: false,
    //                 timer: 1000
    //               }).then(res=>{
    //                 window.location.reload();
    //               })
    //             }
    //           });
    //         }
    //       })
    //     }
    //   })
    // }else{
    //   this.farmService.getUpdateActiveSchedule(data).subscribe(async success => {
    //     $('#setActive').modal('hide');
    //     if (success.code == 200) {
    //       Swal.fire({
    //         icon: 'success',
    //         title: 'ดำเนินการเสร็จสิ้น',
    //         showConfirmButton: false,
    //         timer: 1000
    //       }).then(res=>{
    //         window.location.reload();
    //       })
    //     } else {
    //       Swal.fire({
    //         icon: 'error',
    //         title: 'เกิดข้อผิดพลาด',
    //         showConfirmButton: false,
    //         timer: 1000
    //       }).then(res=>{
    //         window.location.reload();
    //       })
    //     }
    //   });
    // }
    this.farmService
      .getUpdateActiveSchedule(data)
      .subscribe(async (success) => {
        $("#setActive").modal("hide");
        if (success.code == 200) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการเสร็จสิ้น",
            showConfirmButton: false,
            timer: 1000,
          }).then((res) => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            showConfirmButton: false,
            timer: 1000,
          }).then((res) => {
            window.location.reload();
          });
        }
      });
  }

  setDelete(data) {
    $("#DeleteSch").modal("show");
    this.arrdataDel = data;
  }

  deleteScheduleAndCondition(item) {
    let data = {
      thing_id: this.thingId,
      sensor_id: this.sensorId,
      sch_id: item.data.sch_id,
      sch_start_time: item.data.sch_start_time,
      id: item.data.id,
    };

    // let conditions = JSON.parse(item.data.condition);

    // if(this.sensor.auto_sync_flag && item.data.online_config_id && conditions.length == 1){
    //   let keyBasic = conditions[0].sensor_name;
    //   let keyStart = "";
    //   let keyEnd = "";

    //   if(conditions[0].operation == "<"){
    //     keyStart = keyBasic + "_LOW";
    //   }else if(conditions[0].operation == ">"){
    //     keyStart = keyBasic + "_HIGH";
    //   }else if(conditions[0].operation == "="){
    //     keyStart = keyBasic + "_EQUAL";
    //   }else if(conditions[0].operation == "<>"){
    //     keyStart = keyBasic + "_NOT_EQUAL";
    //   }else{
    //     keyStart = keyBasic + "_BETWEEN_MIN";
    //     keyEnd = keyBasic + "_BETWEEN_MAX";
    //   }

    //   this.farmService.getOnlineConfigById(item.data.online_config_id).subscribe(res=>{
    //     if(res.code == 200){

    //       let config = res.data.OnlineConfigInfo;

    //       for (var key in config.CustomDetails) if (key.startsWith(keyBasic)) {
    //         delete config.CustomDetails[keyStart];
    //         delete config.CustomDetails[keyEnd];
    //       }

    //       const keys = Object.keys(config.CustomDetails).filter(key => key.startsWith(keyBasic));
    //       if (keys.length == 1) {
    //           delete config.CustomDetails[keyBasic];
    //       }

    //       this.farmService.updateOnlineConfig(config, config.OnlineConfigId).subscribe(res=>{
    //         if(res.code == 200){
    //           this.deleteScheduleDetail(data);
    //         }
    //       })
    //     }else{
    //       this.deleteScheduleDetail(data);
    //     }
    //   })
    // }else{
    //   this.deleteScheduleDetail(data);
    // }
    this.deleteScheduleDetail(data);
  }

  deleteScheduleDetail(data) {
    this.farmService.getDeleteSchedule(data).subscribe(async (success) => {
      $("#DeleteSch").modal("hide");
      if (success.code == 200) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการเสร็จสิ้น",
          showConfirmButton: false,
          timer: 1000,
        }).then((res) => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          showConfirmButton: false,
          timer: 1000,
        }).then((res) => {
          window.location.reload();
        });
      }
    });
  }

  getSensorofCondition(data) {
    let status = [];
    let ope = [];

    status["ON"] = "เปิดเครื่อง";
    status["OFF"] = "ปิดเครื่อง";

    ope["OR"] = "หรือ";
    ope["AND"] = "และ";

    const element = data.condition[0];

    this.txtContiionOne =
      element.thing_name +
      " " +
      element.sensor_name +
      " " +
      this.convertOperation(element.operation) +
      " " +
      element.Value1 +
      " " +
      status[element.sensor_action] +
      " " +
      element.sch_time +
      " " +
      this.convertUnit(element.sch_unit_time);
    if (element.Value2) {
      this.txtContiionOne =
        element.thing_name +
        " " +
        element.sensor_name +
        " " +
        this.convertOperation(element.operation) +
        " " +
        element.Value1 +
        " ถึง " +
        element.Value2 +
        " " +
        status[element.sensor_action] +
        " " +
        element.sch_time +
        " " +
        this.convertUnit(element.sch_unit_time);
    }

    if (data.condition[1]) {
      const element1 = data.condition[1];
      if (element1.Value2) {
        this.txtContiionOne =
          element.thing_name +
          " " +
          element.sensor_name +
          " " +
          this.convertOperation(element.operation) +
          " " +
          element.Value1 +
          " " +
          status[element.sensor_action] +
          " " +
          element.sch_time +
          " " +
          this.convertUnit(element.sch_unit_time) +
          " " +
          ope[data.data.operation] +
          " " +
          element1.thing_name +
          " " +
          element1.sensor_name +
          " " +
          this.convertOperation(element1.operation) +
          " " +
          element1.Value1 +
          " ถึง " +
          element1.Value2 +
          " " +
          status[element1.sensor_action] +
          " " +
          element1.sch_time +
          " " +
          this.convertUnit(element1.sch_unit_time);
      } else if (element.Value2) {
        this.txtContiionOne =
          element.thing_name +
          " " +
          element.sensor_name +
          " " +
          this.convertOperation(element.operation) +
          " " +
          element.Value1 +
          " ถึง " +
          element.Value2 +
          " " +
          status[element.sensor_action] +
          " " +
          element.sch_time +
          " " +
          this.convertUnit(element.sch_unit_time) +
          " " +
          ope[data.data.operation] +
          " " +
          element1.thing_name +
          " " +
          element1.sensor_name +
          " " +
          this.convertOperation(element1.operation) +
          " " +
          element1.Value1 +
          " " +
          status[element1.sensor_action] +
          " " +
          element1.sch_time +
          " " +
          this.convertUnit(element1.sch_unit_time);
      } else if (element.Value2 && element1.Value2) {
        this.txtContiionOne =
          element.thing_name +
          " " +
          element.sensor_name +
          " " +
          this.convertOperation(element.operation) +
          " " +
          element.Value1 +
          " ถึง " +
          element.Value2 +
          " " +
          status[element.sensor_action] +
          " " +
          element.sch_time +
          " " +
          this.convertUnit(element.sch_unit_time) +
          " " +
          ope[data.data.operation] +
          " " +
          element1.thing_name +
          " " +
          element1.sensor_name +
          " " +
          this.convertOperation(element1.operation) +
          " " +
          element1.Value1 +
          " ถึง " +
          element1.Value2 +
          " " +
          status[element1.sensor_action] +
          " " +
          element1.sch_time +
          " " +
          this.convertUnit(element1.sch_unit_time);
      } else {
        this.txtContiionOne =
          element.thing_name +
          " " +
          element.sensor_name +
          " " +
          this.convertOperation(element.operation) +
          " " +
          element.Value1 +
          " " +
          status[element.sensor_action] +
          " " +
          element.sch_time +
          " " +
          this.convertUnit(element.sch_unit_time) +
          " " +
          ope[data.data.operation] +
          " " +
          element1.thing_name +
          " " +
          element1.sensor_name +
          " " +
          this.convertOperation(element1.operation) +
          " " +
          element1.Value1 +
          " " +
          status[element1.sensor_action] +
          " " +
          element1.sch_time +
          " " +
          this.convertUnit(element1.sch_unit_time);
      }
    }

    return this.txtContiionOne;
  }

  convertOperation(data) {
    let operationSet = [];

    operationSet[">"] = "มากกว่า";
    operationSet["<"] = "น้อยกว่า";
    operationSet["="] = "เท่ากับ";
    operationSet["<>"] = "ไม่เท่ากับ";
    operationSet["BETWEEN"] = "ระหว่าง";

    return operationSet[data];
  }
  returnEdit(data) {
    this.showEdit = data;
  }
  setEdit(data) {
    $("#editSchedual").modal("show");
    this.showEdit = true;
    this.spinner.show();
    setTimeout(async () => {
      $("#edit_id").val(data.data.sch_id);
      $("#start_time").val(data.data.sch_start_time);
      $("#id_row").val(data.data._id);
      this.spinner.hide();
    }, 10);
  }

  clear() {
    $("#editSchedual").modal("hide");
    this.showEdit = false;
    this.spinner.show();
    setTimeout(async () => {
      $("#edit_id").val("");
      this.spinner.hide();
    }, 10);
  }

  cancelSchdule_Condition() {
    this.spinner.show();
    setTimeout(async () => {
      $("#schedual_chx").prop("checked", false);

      $("#Schedule").addClass("dis-none");
      $("#customSwitchSCH").prop("checked", false);
      $("#schedule_DMY").val("");
      // this.type = [];
      $("#schedual_time_start").val("");
      $("#customSwitchSCH").val("");
      // this.txtSw = "ปิด";
      $("#schedule_time_input").val("");
      $("#schedule_time").val("");
      // this.formSchedual.value.schedual_type = "";
      // this.formSchedual.get('schedual_time_start')['controls'] = [];
      // const checkTimeStart = <FormArray>this.formSchedual.get('schedual_time_start') as FormArray;
      // checkTimeStart.push(this.farm.group({
      //   time_start: ''
      // }))
      // this.formSchedual.value.schedual_time_start = "";
      // this.formSchedual.value.schedual_work = "";
      // this.formSchedual.value.schedual_time = "";
      // this.formSchedual.value.schedual_time_unit = "";

      //<.....condition......>
      $("#condition").prop("checked", false);

      $("#condition_main").addClass("dis-none");
      $("#thing_id").val("");
      $("#condition_sensor").val("");
      $("#condition_con").val("");
      $("#condition_val").val("");
      $("#condition_val_start").val("");
      $("#condition_val_end").val("");
      $("#customSwitch2").val("");
      $("#condition_time_input").val("");
      $("#condition_time").val("");
      $("#customSwitch2").prop("checked", false);
      // this.formSchedual.value.thing_id = "";
      // this.formSchedual.value.sensor_id = "";
      // this.formSchedual.value.condition = "";
      // this.formSchedual.value.target1 = "";
      // this.formSchedual.value.target2 = "";
      // this.formSchedual.value.switch_main = "";
      // this.formSchedual.value.time = "";
      // this.formSchedual.value.time_unit = "";

      $("#pnCondition").addClass("dis-none");

      $("#condition_and_or").val("");
      $("#other_thing_id").val("");
      $("#other_condition_sensor").val("");
      $("#other_condition").val("");
      $("#condition_and_or_val").val("");
      $("#condition_and_or_val_start").val("");
      $("#condition_and_or_val_end").val("");
      $("#other_switch_main").val("");
      $("#condition_and_or_time_input").val("");
      $("#condition_and_or_time").val("");
      $("#other_switch_main").prop("checked", false);
      // this.formSchedual.value.other_thing_id = "";
      // this.formSchedual.value.other_sensor_id = "";
      // this.formSchedual.value.other_condition = "";
      // this.formSchedual.value.other_target1 = "";
      // this.formSchedual.value.other_target2 = "";
      // this.formSchedual.value.other_switch_main = "";
      // this.formSchedual.value.other_time = "";
      // this.formSchedual.value.other_time_unit = "";

      this.spinner.hide();
    }, 10);
  }

  // issue#115, #71
  cancelControl() {
    window.location.reload();
  }

  // getDay(data) {
  //   let day = [];
  //   let mrgDay = [];
  //   day[1] = "MON";
  //   day[2] = "TUE";
  //   day[3] = "WED";
  //   day[4] = "THU";
  //   day[5] = "FRI";
  //   day[6] = "SAT";
  //   day[7] = "SUN";

  //   for (let index = 1; index < day.length; index++) {
  //     const element = day[index];
  //     data.forEach(elements => {
  //       elements.data.DateArray.forEach(elementD => {
  //         if (elementD != "") {
  //           if (elements.data.sch_start_time != null) {
  //             let spiltStartTime = elements.data.sch_start_time.split(".");
  //             let splitM = spiltStartTime[0].split("0");
  //             if (splitM[0] == "") {
  //               splitM = splitM[1];
  //             } else {
  //               splitM = spiltStartTime[0];
  //             }

  //             if (elementD == element) {
  //               mrgDay.push({
  //                 time: splitM,
  //                 data: elements.data,
  //                 condition: elements.condition,
  //                 day: element,
  //                 dayMrg: elements.day
  //               })
  //             }
  //           }
  //         }
  //       });

  //     })
  //   }

  //   let group = mrgDay.reduce((result, item) => {
  //     if (!result[item.time]) {
  //       result[item.time] = [];
  //     }
  //     result[item.time].push(item);
  //     return result;
  //   }, {});

  // }

  syncConfig() {
    if (this.thingsByid.length == 1) {
      let thing = this.thingsByid[0];

      this.farmService.getClientConfig(thing._id).subscribe(async (res) => {
        if (res.code == 200) {
          let config = res.data.ThingConfigInfo.ClientConfig;

          let configs = await this.schedualDetailService.mapConfigs(config);

          let findConfig = this.schedualDetailService.getOnlineConfig(
            this.onlineConfigs,
            thing.thing_id
          );

          let conditions = this.schedualDetailService.getCondition(
            this.arrData,
            thing._id
          );

          let operationSet = [];
          operationSet["1"] = ">";
          operationSet["2"] = "<";
          operationSet["3"] = "=";
          operationSet["4"] = "<>";
          operationSet["5"] = "BETWEEN";

          configs = configs
          .map((config) => {
            config.conditions = config.conditions.map(con=>{
    
              let condition = conditions.find((condition) =>
                operationSet[con.condition] == condition.condition[0].operation &&
                    condition.condition[0].sensor_id == config.group
              );
              if(condition){
                let operation = operationSet[con.condition];
                let custom = condition.condition.find(item=> 
                    item.operation == operation);
                con.time = custom? parseInt(custom.sch_time): con.time;
                con.time_unit = custom? custom.sch_unit_time: con.time_unit
              }
              return {
                ...con,
                selected: condition? true: false, 
              };
            }).filter((con) => con.selected);
            return {
              ...config,
            };
            
          }).filter((config) => config.conditions.length > 0);

          if (configs.length > 0) {
            if (findConfig) {
              let filter = {
                online_config_id: findConfig.OnlineConfigId,
                account_id: this.accountId
              }
              this.farmService.getOnlineConfig(filter).subscribe(res=>{
                if(res.code == 200){
                  let config = this.setConfigData(thing, configs, findConfig);

                  this.farmService
                    .updateOnlineConfig(config, findConfig.OnlineConfigId, this.accountId)
                    .subscribe((res) => {
                      if (res.code == 200) {
                        this.updateCondition(
                          thing,
                          configs,
                          findConfig.OnlineConfigId
                        );
                      } else {
                        this.error();
                      }
                    });
                }else{
                  let config = this.setConfigData(thing, configs);

                  this.farmService.createOnlineConfig(config).subscribe((res) => {
                    if (res.code == 200) {
                      this.updateCondition(
                        thing,
                        configs,
                        res.data.OnlineConfigInfo.OnlineConfigId
                      );
                    } else {
                      this.error();
                    }
                  });
                }
              })
            } else {
              let config = this.setConfigData(thing, configs);

              this.farmService.createOnlineConfig(config).subscribe((res) => {
                if (res.code == 200) {
                  this.updateCondition(
                    thing,
                    configs,
                    res.data.OnlineConfigInfo.OnlineConfigId
                  );
                } else {
                  this.error();
                }
              });
            }
     
          } else {
            this.success();
          }
        }
      });
    } else if (this.thingsByid.length > 1) {
      $("#syncConfig").modal("show");
    } else {
      this.success();
    }
  }

  updateCondition(thing, configs, online_config_id) {
    let operationSet = [];
    operationSet["1"] = ">";
    operationSet["2"] = "<";
    operationSet["3"] = "=";
    operationSet["4"] = "<>";
    operationSet["5"] = "BETWEEN";

    configs.map((config, index: number) => {
      config.conditions.map((con) => {
        let operation = operationSet[con.condition];
        let condition = [
          {
            thing_id: thing.thing_id,
            thing_name: thing.thing_name,
            sensor_id: config.group,
            sensor_name: config.group,
            operation: operation,
            Value1: con.target_start,
            Value2: con.target_end == "" ? null : con.target_end,
            sch_time: con.time,
            sch_unit_time: con.time_unit,
            sensor_action: con.switch_main == true ? "ON" : "OFF",
          },
        ];

        let jsonData = JSON.stringify(condition);

        let data = [
          {
            sch_name: "",
            sch_type: null,
            sch_date: "",
            sch_time: null,
            sch_unit_time: null,
            sch_start_time: "00.00.00",
            sch_stop_time: "00.00.00",
            thing_id: this.thingId,
            sensor_id: this.sensorId,
            condition: jsonData,
            operation: null,
            sensor_action: con.switch_main ? "ON" : "OFF",
            sch_flag: "CON",
            plot_id: this.plotId,
            sch_status: con.sch_status,
            online_config_id: online_config_id,
          },
        ];
        let findCondition = this.arrData.find((con) =>
          con.condition.find(
            (item) =>
              item.thing_id == thing.thing_id &&
              item.sensor_id == config.group &&
              item.sensor_name == config.group &&
              item.operation == operation
          )
        );

        if (findCondition) {
          data[0]["sch_id"] = findCondition.data.sch_id;
          data[0]["_id"] = findCondition.data._id;
          this.farmService
            .getUpdateSchedulebyId(data)
            .subscribe(async (success) => {
              if (success.code == 200) {
                this.success();
              } else {
                this.error();
              }
              if(index+1 == configs.length){
                this.cancelControl();
              }
            });
        }
      });
    });
  }

  setConfigData(thing, configs, findConfig = null) {
    let operationSet = [];
    operationSet["1"] = ">";
    operationSet["2"] = "<";
    operationSet["3"] = "=";
    operationSet["4"] = "<>";
    operationSet["5"] = "BETWEEN";
    let CustomDetails = {};
    if (findConfig) {
      CustomDetails = {
        ...findConfig.CustomDetails,
      };
    }
    configs.map((config) => {
      config.conditions.map((condition) => {
        let operation = this.schedualDetailService.convertOperation(
          config,
          condition
        );

        if (findConfig) {
          let findCondition = this.arrData.find((con) =>
            con.condition.find(
              (item) =>
                item.thing_id == thing.thing_id &&
                item.sensor_id == config.group &&
                item.sensor_name == config.group &&
                item.operation == operationSet[condition.condition]
            )
          );
          if (findCondition) {
            let beforeCondition = findCondition.condition[0];
            let beforeOperation = this.schedualDetailService.convertOperation(
              config,
              beforeCondition
            );

            if (
              CustomDetails[beforeCondition.sensor_name] &&
              (CustomDetails[beforeOperation.keyStart] ||
                CustomDetails[beforeOperation.keyEnd])
            ) {
              for (var key in CustomDetails)
                if (key.startsWith(beforeCondition.sensor_name)) {
                  delete CustomDetails[beforeOperation.keyStart];
                  delete CustomDetails[beforeOperation.keyEnd];
                }
            }
          }
        }

        CustomDetails = {
          ...CustomDetails,
          [config.group]: condition.sch_status == "ATV"? "1":"0",
        };

        CustomDetails[operation.keyStart] = condition.target_start;
        if (operation.keyEnd) {
          CustomDetails[operation.keyEnd] = condition.target_end;
        }
      });
    });

    let result =  {
      OnlineConfigName: findConfig
        ? findConfig.OnlineConfigName
        : thing.thing_name,
        "AccountId": this.accountId,
      Things: [thing.thing_id],
      CustomDetails: CustomDetails,
    }; 
    if (findConfig == null) {
      result["AccountId"] = this.accountId
    }
    return result;
  }

  success() {
    Swal.fire({
      icon: "success",
      title: "ดำเนินการเสร็จสิ้น",
      showConfirmButton: false,
      timer: 1500,
    });
  }

  error() {
    Swal.fire({
      icon: "error",
      title: "เกิดข้อผิดพลาดในการสร้าง กรุณาลองใหม่อีกครั้ง",
      showConfirmButton: false,
      timer: 1500,
    });
  }
}
